import React, { FC } from "react";
import { IKohderekisteri } from "../../../sg-kohderekisterit/IKohderekisteri";
import { LocationName } from "./default/LocationName"

export interface IConfiguredComponents {
    ContextProvider: FC<{ token?: string; lang?: string, anonymousSession: boolean; registerSettings: any }>;
    LocationName: IKohderekisteri["LocationName"];
    LocationFilter?: IKohderekisteri["LocationFilter"]

    LocationMap: IKohderekisteri["LocationMap"];
    RenderMap: IKohderekisteri["RenderMap"];

};


export const defaultConfiguredComponents: IConfiguredComponents = {

    ContextProvider: (props) => React.createElement("div", props),


    LocationName,
    LocationMap: (props) => React.createElement("div", props),

    RenderMap: (props) => React.createElement("div", props),

};